import React, { useState, useCallback, useEffect } from "react";
import { Container, Content, Title, Field, Input, Label } from "./styles";

import {
  Modal,
  Button,
  Checkbox,
  Icon,
  Dropdown,
  Form,
  TextArea,
  Tab,
} from "semantic-ui-react";

import { producaov2 as api } from "../../../services/apis";

import swal from "sweetalert";

const TreinamentosSelector = (props) => {
  const [treinamento, setTreinamento] = useState([]);
  const [treinamentoText, setTreinamentoText] = useState("");
  const [treinamentosOptions, setTreinamentosOptions] = useState([]);
  const [treinamentoSearch, setTreinamentoSearch] = useState("");

  const getTreinamentos = useCallback(
    async (search = "") => {
      try {
        const params = {
          search_id_curso: 1,
          allReduced: 1,
          ativo: "S",
        };

        if (search) {
          params.nome = search;
        }

        const treinamentos = (
          await api.get(
            "/admin/treinamentos",
            { params },
            {
              headers: {
                access_token: `voitto-token ${localStorage.getItem(
                  "oauth_token"
                )}`,
              },
            }
          )
        ).data;

        const newOptions = treinamentos.map((treinamento) => ({
          key: treinamento.id,
          text: `${treinamento.nome} - [${treinamento.curso}]`,
          value: treinamento.id,
        }));

        const existingOptions = treinamentosOptions.filter((option) =>
          props.multiple
            ? treinamento.includes(option.value)
            : treinamento === option.value
        );

        const options = newOptions.concat(existingOptions);

        setTreinamentosOptions(options);
      } catch (err) {
        return;
      }
    },
    [props, treinamentosOptions]
  );

  const handleTreinamentoChange = useCallback(
    (e, { value }) => {
      setTreinamento(value);
    },
    [props]
  );

  const handleTreinamentoSearchChange = useCallback((e) => {
    const search = e.target.value;

    setTreinamentoSearch(search);

    getTreinamentos(search);
  });

  const initialLoad = useCallback(async () => {
    try {
      if (
        !props.initialValue ||
        props.initialValue.length === 0 ||
        treinamento.length > 0
      ) {
        return;
      }

      if (props.multiple) {
        const ids = props.initialValue;
        if (!Array.isArray(ids) || ids.length === 0) {
          return;
        }

        const newTreinamentosOptions = await Promise.all(
          props.initialValue.map(async (id, index) => {
            const treinamentoResponse = (
              await api.get(`/admin/treinamentos/${id}`, {
                headers: {
                  access_token: `voitto-token ${localStorage.getItem(
                    "oauth_token"
                  )}`,
                },
              })
            ).data;

            return {
              key: id,
              text: treinamentoResponse.nome,
              value: treinamentoResponse.id,
            };
          })
        );

        const newTreinamentoText = newTreinamentosOptions
          .filter((option) => ids.includes(option.value))
          .map(({ text }) => text);

        setTreinamentosOptions(newTreinamentosOptions);
        setTreinamentoText(newTreinamentoText);
        setTreinamento(ids);

        return;
      }

      const id = props.initialValue;

      const treinamentoResponse = (
        await api.get(`/admin/treinamentos/${id}`, {
          headers: {
            access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
          },
        })
      ).data;

      const newTreinamentosOptions = [
        {
          key: id,
          text: treinamentoResponse.nome,
          value: treinamentoResponse.id,
        },
      ];

      setTreinamentosOptions(newTreinamentosOptions);
      setTreinamentoText(treinamentoResponse.nome);
      setTreinamento(id);
    } catch (err) {
      console.error(err);
      return;
    }
  }, [props.initialValue, props.multiple, treinamento.length]);

  useEffect(() => {
    initialLoad();
  }, [initialLoad]);

  const handleChange = useCallback(() => {
    props.handleChange(treinamento);
  }, [props, treinamento]);

  useEffect(() => {
    handleChange();
  }, [treinamento, treinamentosOptions]);

  useEffect(() => {
    if (Array.isArray(treinamento)) {
      const selectedOptions = treinamento.map((id) => {
        const option = treinamentosOptions.find(
          (option) => option.value === id
        );
        return option || { key: id, text: id, value: id };
      });

      setTreinamentosOptions((prevOptions) => {
        const newOptions = prevOptions.filter(
          (option) => !treinamento.includes(option.value)
        );
        return [...newOptions, ...selectedOptions];
      });
    }
  }, [treinamento]);

  return (
    <Container>
      <div>
        <Label>Selecione o treinamento</Label>
        <Dropdown
          placeholder="Busque pelo nome do Treinamento"
          fluid
          search
          selection
          clearable={props.clearable}
          multiple={props.multiple}
          options={treinamentosOptions}
          onChange={handleTreinamentoChange}
          // searchQuery={treinamentoSearch}
          onSearchChange={handleTreinamentoSearchChange}
          value={treinamento}
        />
      </div>
    </Container>
  );
};

export default TreinamentosSelector;
